

<template>
  <section class="rank-main">
    <div class="rank-content">
      <div class="user-info">
        <img :src="detail.user_avatar_att_url || require('@/assets/images/news-default.png')" alt="">
        <div class="user-info-item">
          <span class="user-name">{{detail.user_nick_name}}</span>
          <!-- <span class="user-points">{{detail.tpsn_score}}{{$t('积分')}}</span> -->
        </div>
      </div>
      <div class="content">
        <!-- 积分类型切换 -->
        <div class="tabs-container">
          <el-tabs v-model="tas_id" @tab-click="handleTabChange">
            <el-tab-pane v-for="item in stageList" :key="item.tas_id" :label="item.tas_title" :name="item.tas_id+''"></el-tab-pane>
            <!-- <el-tab-pane label="初赛积分" name="1"></el-tab-pane>
            <el-tab-pane label="复赛积分" name="2"></el-tab-pane>
            <el-tab-pane label="决赛积分" name="3"></el-tab-pane> -->
          </el-tabs>
        </div>

        <div class="points-total">
          <div class="points-total-item" v-if="stageList[0] && tas_id==stageList[0].tas_id">
            {{stageList[0].tas_title}}{{ $t('总积分') }}：{{detail.tpsn_stage_one}}
          </div>
          <div class="points-total-item" v-if="stageList[1] && tas_id==stageList[1].tas_id">
            {{stageList[1].tas_title}}{{ $t('总积分') }}：{{detail.tpsn_stage_tow}}
          </div>
          <div class="points-total-item" v-if="stageList[2] && tas_id==stageList[2].tas_id">
            {{stageList[2].tas_title}}{{ $t('总积分') }}：{{detail.tpsn_stage_three}}
          </div>
          <div class="desc">{{ $t('答题审核通过后，更新明细') }}</div>
        </div>
      
        <!-- 活动暂未开始的提示内容-->
        <!-- <div class="activity-not-start" v-if="pointsData.length == 0">
          <img src="@/assets/images/weikaishi.png" alt="">
          <div class="text">{{$t('活动未开始')}}</div>
        </div> -->

				<div class="activity-not-start" v-if="pointsData.length == 0">
					<img src="@/assets/images/empty_data.png" alt />
					<p class="text">{{ $t('暂无数据') }}</p>
				</div>

        <template v-if="pointsData.length > 0">
          <!-- 分数表格 
            :height="tableHeight" -->
          <el-table 
            :loading="loading"
            :data="pointsData" 
            stripe
            @sort-change="handleSortChange"
            row-key="tasqs_id"
            @row-click="handleRowClick"
            :expand-row-keys="expandedKeys"
            >
            
            <!-- 可展开行 -->
            <el-table-column type="expand" width="15">
              <template slot-scope="props">
                <div class="question-detail">
                  <!-- 每周每日一答----- start -->
                  <template v-if="props.row.dd_question_type=='10' || props.row.dd_question_type=='20'">
                    <div
                    v-for="(question, index) in props.row.questionuser" :key="index" class="question-item">
                      <div class="question-title">
                        {{index+1}}、 {{question.question.taspq_title}} 
                        <span class="req" v-if="question.question.taspq_require==10">*</span>
                        <span class="question-type" v-if="question.question.taspq_type">{{ $t(quesType[question.question.taspq_type]) }}</span>
                      </div>
                      <div class="options">
                        <div 
                          v-for="(option, optIndex) in question.question.taspq_options" 
                          :key="optIndex" 
                          class="option">
                          {{getAnswerText(optIndex)}}、 {{option.title}}
                            <!-- 评分 -->
                          <div class="score-box" v-if="question.question.taspq_type==30">
                            <span class="score-label">{{ option.score_min_title }}</span>
                            <el-rate 
                              disabled
                              v-model="question.tasqu_value[optIndex].title" 
                              :min="parseInt(option.score_min)" 
                              :max="parseInt(option.score_max)"></el-rate>
                            <span class="score-label">{{ option.score_max_title }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="comment" v-if="question.question.taspq_type==10">
                        {{ $t('你的答案是') }}: 
                        {{ getAnswerText(question.tasqu_value.value) }},
                        <template v-if="props.row.tasqs_status != 'wait'">
                          {{ $t('正确答案是') }}: {{ getAnswerText(question.question.taspq_options,3) }}
                        </template>
                      </div>
                      <div class="comment" v-if="question.question.taspq_type==20">
                        {{ $t('你的答案是') }}: 
                        {{ getAnswerText(question.tasqu_value,2) }}，
                        <template v-if="props.row.tasqs_status != 'wait'">
                          {{ $t('正确答案是') }}: {{ getAnswerText(question.question.taspq_options,1) }}
                        </template>
                      </div>
                      
                      <div v-if="question.question.taspq_type==40">
                        <div class="jdtext mb-8">{{ question.tasqu_value.title}}</div>

                        <div v-if="question.reject_time" class="comment question-item mb-8">
                          <!-- {{question.reject_time}}：<span class="question-type red mr-12">{{ $t('审核被驳回') }}</span> <span>{{ question.tasqu_reject_msg }} -{{ question.tasqu_reject_score }}</span> -->
                          <span>{{question.reject_time}}：</span>
                          <span>{{ $t("抱歉") }},</span>
                          <span>
                            {{ $t('你提交的赛题') }}，{{$t('组委会')}}
                          </span>
                          <span class="question-type red mr-12">{{ $t('审核被驳回') }}</span>
                          <span>-{{ question.tasqu_reject_score }}</span>
                          <div class="comment">
                            {{ $t('驳回意见') }}: <span>{{question.tasqu_reject_msg}}</span>
                          </div>
                        </div>
                        
                        <span v-if="props.row.audit_time">{{props.row.audit_time}}：</span>
                        <span>
                          {{ $t('你提交的赛题') }}，{{$t('组委会')}}
                        </span>

                        <span class="question-type red" v-if="question.tasqu_status=='wait'">{{ $t('审核中') }}</span>

                        <template v-if="question.tasqu_status=='success' || question.reject_time">
                          <span class="question-type green">{{ $t('已经完成审核') }}</span>
                          <span class="ml-12">+{{ question.reject_time ? question.tasqu_reject_score : question.tasqu_score }}</span>
                        </template>

                        <span class="question-type red" v-if="question.tasqu_status=='error' && !question.reject_time">{{ $t('已驳回') }}</span>

                        <template v-if="question.tasqu_status != 'wait'">
                          <div v-if="question.tasqu_status=='success' || question.reject_time" class="comment">
                            {{ $t('审核意见') }}: 
                            <span v-if="question.tasqu_score==0">{{$t('赛题审核已通过')}}</span>
                            <span v-else>{{$t('赛题审核已通过，恭喜您获得本题积分')}}</span>
                          </div>
                          <div v-if="question.tasqu_status=='error' && !question.reject_time" class="comment">
                            {{ $t('审核意见') }}: <span>{{question.tasqu_audit_msg}}</span>
                          </div>
                        </template>

                      </div>
                    </div>
                  </template>
                  <!-- 每周每日一答----- end -->


                  <div v-else class="question-item">
                    <template v-if="props.row.dd_question_type==-1000">
                      <div v-if="props.row.reject_time" class="comment mb-8">
                        <span>
                        {{props.row.reject_time}}：{{ $t("抱歉，您参与的“xxx”，裁判打分被驳回 -xx分",{xxx:props.row.dd_question_title,num:props.row.tasqs_reject_score}) }}
                        </span>
                      </div>
                      <div v-if="props.row.reject_time" class="comment">
                        <span>{{ $t('驳回原因') }}:</span> <span>{{props.row.tasqs_reject_msg}}</span>
                      </div>
                      <div class="question-title">
                        <span v-if="props.row.audit_time">{{props.row.audit_time}}：</span>{{$t("您参与的“xxx”，组委会裁判给您打分num",{xxx:props.row.dd_question_title,num: props.row.reject_time ? props.row.tasqs_reject_score : props.row.tasqs_score}) }}
                        <div v-if="props.row.importlog && props.row.importlog.tassil_remarks">{{$t("打分理由")}}：{{ props.row.importlog.tassil_remarks }}</div>
                      </div>
                    </template>
                    <template v-else>


                      <div v-if="props.row.reject_time" class="comment mb-8">
                        <!-- <span>{{props.row.reject_time}}：</span><span class="question-type red mr-12">{{ $t('审核被驳回') }}</span> <span>{{ props.row.tasqs_reject_msg }} -{{ props.row.tasqs_reject_score }}</span> -->
                        <div class="question-title">
                          <span>{{props.row.reject_time}}：</span>
                          <span>{{ $t("抱歉") }},</span>
                          <span v-if="props.row.dd_question_type=='30'">
                            {{ $t('你申请的') }}{{props.row.questionuser[0].tasqu_value.taspq_title}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='40' && props.row.questionuser[0].tasqu_value.value==10">
                            {{props.row.questionuser[0].tasqu_value.ta_title}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='40'">
                            {{ $t('你在') }}{{props.row.questionuser[0].tasqu_value.ta_title}}{{$t('活动现场签到')}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='50'">
                            {{ $t('你在') }}{{props.row.questionuser[0].tasqu_value.ta_title}}{{$t('活动演讲证明')}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='60' && props.row.tasqs_is_premium!=10" v-throttle="1000" @click="toDiscuss(props.row)" class="aspan">
                            {{ $t('您撰写的') }}{{props.row.questionuser[0].tasqu_value.tp_title}}{{$t('文章')}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='60' && props.row.tasqs_is_premium==10" v-throttle="1000" @click="toDiscuss(props.row)" class="aspan">
                            {{ $t('您撰写的') }}{{props.row.questionuser[0].tasqu_value.tp_title}}{{$t('文章')}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="isChallengeShortVideo(props.row)" v-throttle="1000" @click="toDiscuss(props.row)" class="aspan">
                            {{ $t('您发布的') }}{{ shortVideoPointsTitle(props.row) }}{{$t('短视频')}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='70'">
                            {{ $t('你提交的') }}{{props.row.questionuser[0].tasqu_value.title}}{{$t('项目下单记录')}}，{{$t('组委会')}}
                          </span>
                          <span v-else-if="props.row.dd_question_type=='80'">
                            {{ $t('你提交的') }}{{props.row.questionuser[0].tasqu_value.taspq_title}}{{$t('证书')}}，{{$t('组委会')}}
                          </span>
                          <span class="question-type red mr-12">{{ $t('审核被驳回') }}</span>
                          <span class="ml-12">-{{ props.row.tasqs_reject_score }}</span>
                        </div>
                        <div class="comment">
                          {{ $t('驳回意见') }}: <span>{{props.row.tasqs_reject_msg}}</span>
                        </div>
                      
                      </div>


                      <div class="question-title">
                        <span v-if="props.row.audit_time">{{props.row.audit_time}}：</span>
                        <span v-if="props.row.dd_question_type=='30'">
                          {{ $t('你申请的') }}{{props.row.questionuser[0].tasqu_value.taspq_title}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='40' && props.row.questionuser[0].tasqu_value.value==10">
                          {{props.row.questionuser[0].tasqu_value.ta_title}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='40'">
                          {{ $t('你在') }}{{props.row.questionuser[0].tasqu_value.ta_title}}{{$t('活动现场签到')}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='50'">
                          {{ $t('你在') }}{{props.row.questionuser[0].tasqu_value.ta_title}}{{$t('活动演讲证明')}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='60' && props.row.tasqs_is_premium!=10" v-throttle="1000" @click="toDiscuss(props.row)" class="aspan">
                          {{ $t('您撰写的') }}{{props.row.questionuser[0].tasqu_value.tp_title}}{{$t('文章')}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='60' && props.row.tasqs_is_premium==10" v-throttle="1000" @click="toDiscuss(props.row)" class="aspan">
                          {{ $t('您撰写的') }}{{props.row.questionuser[0].tasqu_value.tp_title}}{{$t('文章')}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="isChallengeShortVideo(props.row)" v-throttle="1000" @click="toDiscuss(props.row)" class="aspan">
                          {{ $t('您发布的') }}{{ shortVideoPointsTitle(props.row) }}{{$t('短视频')}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='70'">
                          {{ $t('你提交的') }}{{props.row.questionuser[0].tasqu_value.title}}{{$t('项目下单记录')}}，{{$t('组委会')}}
                        </span>
                        <span v-else-if="props.row.dd_question_type=='80'">
                          {{ $t('你提交的') }}{{props.row.questionuser[0].tasqu_value.taspq_title}}{{$t('证书')}}，{{$t('组委会')}}
                        </span>
                        
                        <span v-if="!props.row.questionuser[0].tasqu_value.value">
                          <span class="question-type red" v-if="props.row.tasqs_status=='wait'">{{ $t('审核中') }}</span>
                          
                          <template v-if="props.row.tasqs_status=='success' || props.row.reject_time">
                            <span class="question-type green" v-if="props.row.dd_question_type!='60'">{{ $t('已经完成审核') }}</span>
                            <span class="question-type green" v-else>{{ $t('已审核通过') }}</span>
                            <span class="ml-12">+{{ props.row.reject_time ? props.row.tasqs_reject_score : props.row.tasqs_score }}</span>
                          </template>
                          <span class="question-type red" v-if="props.row.tasqs_status=='error' && !props.row.reject_time">{{ $t('已驳回') }}</span>
                        </span>
                      </div>
                      <div v-if="props.row.tasqs_status=='success' || props.row.reject_time" class="comment">
                        {{ $t('审核意见') }}:
                        <template v-if="isChallengeShortVideo(props.row)">
                          <div>{{ $t('points_short_video_audit_ordinary', { title: shortVideoPointsTitle(props.row) }) }}</div>
                          <div v-if="Number(props.row.tasqs_premium_video_bonus_given) === 10">{{ $t('points_short_video_audit_premium', { title: shortVideoPointsTitle(props.row) }) }}</div>
                          <div v-if="shortVideoPremiumClawbackShow(props.row) && shortVideoPremiumClawbackScoreX(props.row)">{{ $t('points_short_video_premium_clawback', { X: shortVideoPremiumClawbackScoreX(props.row) }) }}</div>
                          <div v-if="Number(props.row.tasqs_proof_score_awarded) > 0">{{ $t('points_short_video_audit_third', { title: shortVideoPointsTitle(props.row) }) }}</div>
                        </template>
                        <span v-else-if="props.row.tasqs_score==0">{{$t('赛题审核已通过')}}</span>
                        <span v-else-if="props.row.tasqs_is_premium!=10">{{$t('赛题审核已通过，恭喜您获得本题积分')}}</span>
                        <span v-else>{{$t('您撰写的“xxx”文章被评为精品文章，恭喜您获得精品文章积分',{xxx:props.row.questionuser[0].tasqu_value.tp_title})}}</span>
                      </div>
                      <div v-if="props.row.tasqs_status=='error' && !props.row.reject_time" class="comment">
                        {{ $t('审核意见') }}: <span>{{props.row.tasqs_audit_msg}}</span>
                      </div>
                    </template>
                
                  </div>
                </div>
               
              </template>
            </el-table-column>
            
            <!-- 项目列 -->
            <el-table-column
              prop="dd_question_title"
              :label="$t('赛题')"
              sortable="custom">
              <template slot="header" slot-scope="scope">
                <div class="custom-sort-header">
                  <span>{{ $t('赛题') }}</span>
                  <div class="sort-icons">
                    <i class="el-icon-arrow-up sort-icon" 
                      :class="{'active-asc': sort === '10' && sort_by === 'asc'}"
                       v-throttle="1000"
                      @click="customSort('10', 'asc')"></i>
                    <i class="el-icon-arrow-down sort-icon" 
                      :class="{'active-desc': sort === '10' && sort_by === 'desc'}"
                       v-throttle="1000"
                      @click="customSort('10', 'desc')"></i>
                  </div>
                </div>
              </template>
              <template slot-scope="scope">
                <span>{{ scope.row.dd_category_title ? scope.row.dd_category_title + " - " : "" }} {{ scope.row.paper.tasp_title }}</span>
              </template>
            </el-table-column>
            
            <!-- 积分列 tasslu_score tasqu_score tasqs_score-->
            <el-table-column
              prop="tasqs_score"
              :label="$t('积分')"  
              sortable="custom">
              <template slot="header" slot-scope="scope">
                <div class="custom-sort-header">
                  <span>{{ $t('积分') }}</span>
                  <div class="sort-icons">
                    <i class="el-icon-arrow-up sort-icon" 
                      :class="{'active-asc': sort === '20' && sort_by === 'asc'}"
                       v-throttle="1000"
                      @click="customSort('20', 'asc')"></i>
                    <i class="el-icon-arrow-down sort-icon" 
                      :class="{'active-desc': sort === '20' && sort_by === 'desc'}"
                       v-throttle="1000"
                      @click="customSort('20', 'desc')"></i>
                  </div>
                </div>
              </template>
              <template slot-scope="scope">
                <span v-if="scope.row.tasqs_status!='wait'">{{ scope.row.tasqs_score }}</span>
              </template>
            </el-table-column>
            
            <!-- 时间列 -->
            <el-table-column
              prop="create_time"
              :label="$t('答题时间')"
              sortable="custom">
              <template slot="header" slot-scope="scope">
                <div class="custom-sort-header">
                  <span>{{ $t('答题时间') }}</span>
                  <div class="sort-icons">
                    <i class="el-icon-arrow-up sort-icon" 
                      :class="{'active-asc': sort === '30' && sort_by === 'asc'}"
                       v-throttle="1000"
                      @click="customSort('30', 'asc')"></i>
                    <i class="el-icon-arrow-down sort-icon" 
                      :class="{'active-desc': sort === '30' && sort_by === 'desc'}"
                       v-throttle="1000"
                      @click="customSort('30', 'desc')"></i>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 分页组件 -->
          <div class="pagination-container-wrapper">
            <div class="total">{{ $t("共n项", {num:total}) }}</div>
            <div class="pagination-container">
              <el-pagination            
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageSize"
                layout="prev, pager, next, jumper, sizes"
                :total="total">
              </el-pagination>
            </div>
          </div>
          <!---------------------- table结束 ------------------>
        </template>

      </div>

    </div>
  </section>
</template>

<script>
import { scoreDetails, myScore, challengestageList } from '@/api/challenge';
import { Loading } from 'element-ui';
export default {
  name: "PointsDetail",
  data() {
    return {
      
      quesType: {
        10: '单选',
        20: '多选',
        30: '评分',
        40: '简答'
      },
      detail:{
        user_nick_name: '',
        user_avatar: '',
        tpsn_score: 0
      },
      loading: false,
      pointsData: [],
      expandedKeys: [],
      tableHeight: 695,
      currentPage: 1,
      pageSize: 20,
      total: 100,
      sort: null,
      sort_by: null,
      tas_id: '1',
      stageList:[],
    };
  },
  computed: {
    ta_id() {
      return this.$route.params.ta_id;
    },
  },
  mounted() {
    // this.calculateTableHeight();
    // window.addEventListener('resize', this.calculateTableHeight)
    this.getStage()
    this.getDetail(); 
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  },
  methods: {
    // 获取用户积分
    async getDetail(){
      const res = await myScore({ 
        ta_id: this.ta_id
      });
      if(res.status == 200){
        this.detail = res.data;
      }
    },
    // 获取阶段列表
    async getStage(){
      const res = await challengestageList({ 
        ta_id: this.ta_id
      })
      if(res.status == 200){
        this.stageList = res.data.list.map(item=>{
          item.tas_id = item.tas_id+''
          return item
        })
        this.tas_id = this.stageList[0].tas_id
        this.getData()
      }
    },
    // 获取积分明细
    async getData(){
      this.loading = true;
      const res = await scoreDetails({ 
        page: this.currentPage,
        paginate: this.pageSize,
        sort: this.sort,
        sort_by: this.sort_by,
        ta_id: this.ta_id,
        tas_id: this.tas_id
      });
      if(res.status == 200){
        this.pointsData = res.data.data;
        this.total = res.data.total;
      }
      this.loading = false
    },
    isChallengeShortVideo(row) {
      if (!row) {
        return false;
      }
      const t = row.dd_question_type;
      return t === 100 || t === '100';
    },
    shortVideoPointsTitle(row) {
      if (!row) {
        return this.$t('短视频');
      }
      const fromRow = row.tasqs_video_title != null && String(row.tasqs_video_title).trim() !== ''
        ? String(row.tasqs_video_title).trim()
        : '';
      let fromQu = '';
      const qu = row.questionuser && row.questionuser[0];
      if (qu && qu.tasqu_value && typeof qu.tasqu_value === 'object') {
        const v = qu.tasqu_value;
        const t = v.tp_title || v.title;
        if (t) {
          fromQu = String(t).trim();
        }
      }
      const s = fromRow || fromQu;
      return s || this.$t('短视频');
    },
    shortVideoPremiumClawbackShow(row) {
      if (!row || !this.isChallengeShortVideo(row)) {
        return false;
      }
      if (Number(row.tasqs_premium_video_flag) !== 20) {
        return false;
      }
      if (Number(row.tasqs_premium_video_bonus_given) === 10) {
        return false;
      }
      return true;
    },
    shortVideoPremiumClawbackScoreX(row) {
      if (!row) {
        return '';
      }
      const paper = row.paper || {};
      const n = parseFloat(paper.tasp_premium_score);
      if (!Number.isFinite(n) || n <= 0) {
        return '';
      }
      if (Math.abs(n - Math.round(n)) < 1e-9) {
        return String(Math.round(n));
      }
      return String(Math.round(n * 100) / 100);
    },
    // 跳转文章详情
    toDiscuss(row){
      this.$router.push({
        path: '/cn/discuss/info/'+row.questionuser[0].tasqu_value.tp_id,
      });
    },
    // 计算表格高度
    calculateTableHeight() {
      this.tableHeight = window.innerHeight - 300;
    },
    // 处理行点击
    handleRowClick(row, column, event) {
      const index = this.expandedKeys.indexOf(row.tasqs_id);
      if (index === -1) { // 如果当前行不在展开的数组中，则添加进去
        this.expandedKeys.push(row.tasqs_id);
      } else { // 如果当前行在展开的数组中，则移除它
        this.expandedKeys.splice(index, 1);
      }
    },
    
    // 处理Tab切换
    handleTabChange() {
      this.currentPage = 1;
      this.sort = null;
      this.sort_by = null;
      this.pointsData = [];
      this.getData();
      this.getDetail(); 
    },
    // 自定义排序处理
    customSort(prop, order) {
      this.sort = prop;
      this.sort_by = order;
      // 触发表格的排序事件
      this.handleSortChange({
        column: null,
        prop: prop,
        order: order
      });
    },
    
    // 处理排序变化
    handleSortChange({ column, prop, order }) {
      if(order == 'ascending'){
        this.sort_by = 'asc';
      }else if(order == 'descending'){
        this.sort_by = 'desc';
      }else{
        this.sort_by = null;
      }
      if(prop == 'dd_question_title'){
        this.sort = '10';
      }else if(prop == 'tasqs_score'){
        this.sort = '20';
      }else if(prop == 'create_time'){
        this.sort = '30';
      }
      this.getData();
    },
    
    // 处理每页显示条数变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    
    // 处理页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getData();
    },
    
    getAnswerText(value,isoption){
      // 将数字转为ABCD选项
      let text = ''
      if(isoption==1){//多选正确答案
        let arr = []
        value.map((item,index)=> {
          if(item.is_right==true){
            arr.push(String.fromCharCode(65 + index))
          }
        })
        text = arr.join('、')
      }else if(isoption==3){//单选正确答案
        value.map((item,index)=> {
          if(item.is_right==true){
            text = String.fromCharCode(65 + index)
          }
        })
      }else if(isoption==2){
        let val2 = JSON.parse(JSON.stringify(value))
        val2.sort((a,b)=>a.value-b.value)
        text = val2.map((item)=> item.value==="" ? "" : String.fromCharCode(65 + item.value)).join('、')
      }else{
        if(value==="" || value===undefined){
          text = '';
        }else{
          text = String.fromCharCode(65 + value)					
        }
      }
      return text
    },
  }
};
</script>
<style lang="scss" scoped>
  .rank-main{
    padding: 80px 120px 20px;
    background: #F9F9F9;
  }
  .rank-content{
    font-family: "微软雅黑";
    min-width: 1200px;
    max-width: 1680px;
    height: 100%;
    margin: 0 auto;
    border-radius: 4px;
    background: #fff;
    min-height: calc(100vh - 80px);
    box-shadow: 0 0 12px 0 rgb(0 0 0 / 10%);
    .user-info{
      display: flex;
      align-items: center;
      padding: 36.69px;;
      width: 100%;
      border-radius: 4px 4px 0px 0px;
      background: linear-gradient(48.62deg, rgb(255, 250, 241) 1.816%,rgba(255, 255, 255, 0) 86.349%); 
      padding: 20px;
      img{
        width: 70.62px;
        height: 70.62px;
        border-radius: 50%;
        margin-right: 12.69px;
        object-fit: cover;
      }
      .user-info-item{
        display: flex;
        justify-content: center;
        flex-direction: column;
        .user-name{
          font-size: 20px;
          color: #191919;
          line-height: 30px;
          margin-bottom: 4px;
        }
        .user-points{
          font-size: 14px;
          color: #FF8000;
          line-height: 22px;
        }
      }
    }
    .content{
      padding: 32px 40px;
      .tabs-container {
        margin-bottom: 24px;
        ::v-deep .el-tabs__header{
          margin-bottom: 0 !important;
        }
      }
      .points-total{
        margin-bottom: 20px;
        .points-total-item{
          font-size: 16px;
          line-height: 24px;
          margin-bottom: 16px;
          color: #191919;
        }
        .desc{
          font-size: 14px;
          line-height: 22px;
          color: #777777;
        }
      }
      .activity-not-start{
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin: 120px auto;
        img{
          width: 72px;
          height: 72px;
          margin-bottom: 16px;
        }
        .text{
          line-height: 22px;
          color: #777777;
        }
      }
      .el-table{
        width: 100%;
        ::v-deep .el-table__header-wrapper th {
          background-color: #F5F7FA;
          color: #191919;
          font-weight: 500;
          padding: 6px 0;
          .cell{
            position: relative;
            height: 28px;
            .search-icon{
              cursor: pointer;
              color: #4D4D4D;
            }
            &.cell::after{ 
              content: '';
              display: block;
              width: 1px;
              height: 16px;
              background-color: #DFDFDF;
              position: absolute;
              right: 0;
              top: 6px;
            }
          }          
          &:nth-child(4){
            .cell::after{
              display: none;
            }
          }

          // 自定义排序按钮布局
        .caret-wrapper {
          display: none !important;
        }
        
        .custom-sort-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          
          .sort-icons {
            display: flex;
            align-items: center;
            flex-direction: column;
            .sort-icon {
              cursor: pointer;
              font-size: 12px;
              color: #595959;
              font-weight: 700;
              height: 8px;
              line-height: 8px;
              &.active-asc {
                color: #0067D1;
              }
              
              &.active-desc {
                color: #0067D1;
              }
            }
          }
        }

        }
        ::v-deep .el-table__row {
          height: 40px;
          td {
            color: #191919;
            padding: 6px 0;
          }
        }
        ::v-deep .cell {
          min-height: 28px;
          display: flex;
          align-items: center;
          width: 100%;
        }
      }
      .question-detail {
        padding: 4px 30px;
        color: #191919;
        .question-item {
          margin-bottom: 16px;
          .aspan{
            cursor: pointer;
            &:hover{
              color: #4d4d4d;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
          
          .score-box{
            display: flex;
            align-items: center;
            margin-top: 8px;
            .score-label{
              font-size: 12px;
              color: #808080;
              margin-right: 8px;
            }
          }
          .question-title {
            line-height: 32px;
            margin-bottom: 8px;
            //display: flex;
            //align-items: center;
            .req{
              color:#E02128;
              margin: 0 4px;
            }
            &:last-child{
              margin-bottom: 0;
            }
          }
          .question-type{
            border-radius: 4px;
            padding: 0 8px;
            height: 24px;
            line-height: 24px;
            font-size: 12px;
            margin-left: 8px;
            background-color: #F5F6F8;
            display: inline-block;
            &.green{
              background-color: #64BB5C26;
              color: #5C8059;
            }
            &.red{
              background-color: #ED6F2126;
              color: #9C554B;
            }
          }
          .jdtext{
            color: #777777;
            line-height: 22px;
            border: 1px solid #E5E5E5;
            border-radius: 4px;
            padding: 10px;
            min-height: 100px;
          }
          .options {
            .option {
              margin-bottom: 8px;
              line-height: 22px;
            }
          }
          .comment{
            color: #777777;
            line-height: 22px;
            span{
              color: #191919;
            }
          }
        }
      }
    }
    .pagination-container-wrapper{
      display: flex;
      justify-content: space-between;
      align-items: center;
      .total{
        font-size: 12px;
        color: #191919;
      }
      .pagination-container {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
      }
    }
    ::v-deep .el-pager li.active {
      background-color: #E6F1FD;
      color: #0067D1;
    }
    ::v-deep .el-pager li:hover {
      color: #0067D1;
    }
    ::v-deep .el-select .el-input.is-focus .el-input__inner,
    ::v-deep .el-input__inner:focus,
    ::v-deep .el-input__inner:hover {
      border-color: #0067D1;
    }
    ::v-deep .el-select-dropdown__item.selected{
      color: #0067D1;
    }
    ::v-deep .el-tabs__item.is-active,
    ::v-deep .el-tabs__item:hover,
    ::v-deep .el-pagination .btn-next:hover,
    ::v-deep .el-pagination .btn-prev:hover{
      color: #0067D1;
    }
    ::v-deep .el-tabs__active-bar{
      background-color: #0067D1;
    }
  }
</style>